import {
    IPutDataGroupCompanyArgs,
    ICompanyGroupHoldingInfoDto,
    ICompanyGroupStatePartInfoDto,
    ICompanyGroupParticipantInfoDto,
    ICompanyGroupShareParentInfoDto,
    ITransfomedPutDataGroupCompanyArgs
} from '../api/types';

const transformHoldingInfo = (holdingDtos: ICompanyGroupHoldingInfoDto[]) => {
    if (!holdingDtos) return [];

    return holdingDtos.map((item) => ({...item, position: item.position.id || item.position}));
};

const transformStatePartInfo = (statePartDtos: ICompanyGroupStatePartInfoDto[]) => {
    if (!statePartDtos) return [];

    return statePartDtos.map((item) => ({...item, statePartType: item.statePartType.id || item.statePartType}));
};

const transformShareParentInfo = (shareParentDtos: ICompanyGroupShareParentInfoDto[]) => {
    if (!shareParentDtos) return [];

    return shareParentDtos.map((shareItem) => ({...shareItem, partType: shareItem.partType.id || shareItem.partType}));
};

const transformParticipantInfo = (participantDtos: ICompanyGroupParticipantInfoDto[]) => {
    if (!participantDtos) return [];

    return participantDtos.map((item) => ({
        ...item,
        subordination: item.subordination.id || item.subordination,
        participantType: item.participantType.id || item.participantType,
        companyGroupShareParentInfoDtos: transformShareParentInfo(item.companyGroupShareParentInfoDtos),
    }));
};

export const transformFormData = (formData: IPutDataGroupCompanyArgs): ITransfomedPutDataGroupCompanyArgs => ({
    id: formData.id,
    inn: formData.inn,
    statePart: formData.statePart.id || formData.statePart,
    companyGroupHoldingInfoDtos: transformHoldingInfo(formData.companyGroupHoldingInfoDtos),
    companyGroupStatePartInfoDtos: transformStatePartInfo(formData.companyGroupStatePartInfoDtos),
    companyGroupParticipantInfoDtos: transformParticipantInfo(formData.companyGroupParticipantInfoDtos),
});
